import './app.css';

import * as React		from 'react';
import {useNavigate}	from "react-router";

import Button			from '@mui/joy/Button';
import Stack			from '@mui/joy/Stack';
import Card				from '@mui/joy/Card';
import CardContent		from '@mui/joy/CardContent';
import CardCover		from '@mui/joy/CardCover';
import Grid				from '@mui/joy/Grid';
import Typography		from '@mui/joy/Typography';

import {config} 		from "./config.js";


function App() {	
	const navigate = useNavigate();

	function handleLoginClick() {
		let uid = localStorage.getItem("username");
		
		if (uid !== "" && uid !== null)
			navigate("/showstops");
		else
			navigate("/login");
	}
		
	const quotes = [
		{
			img: "/david-ricardo.jpg",
			quote: 'Cut short your losses, let your profits run on.',
			author: "David Ricardo, 1772-1823",
			button: ""
		},			
		{
			img: "/mark-minervi.jpg",
			quote: "Love stops. Not stocks.",
			author: "Mark Minervini",
			button: ""				
		},
		{
			img: "/friedrich-nietzsche.jpg",
			quote: "Convictions are more dangerous enemies of truth than lies.",
			author: "Friedrich Nietzsche",
			button: ""
		},
		{
			img: "/bill-gates.jpg",
			quote: "Letting losses run is the most serious mistake made by most investors.",
			author: "William O’Neil",
			button: ""
		},
		{
			img: "/learn.jpg",
			quote: "",
			author: "",
			url: "",
			link: "https://www.stop-loss.se",
			button: "Learn more..."
		},	
		{
			img: "/linda-raschke.jpg",
			quote: "When the ship starts to sink, don't pray - jump!",
			author: "Linda Raschke",
			button: ""
		},			
		{
			img: "/mark-ritchie.jpg",
			quote: "If you are wrong, get out. That’s what a stop is for.",
			author: "Mark Ritchie",
			button: ""
		},			
		{
			img: "/set-stop.jpg",
			quote: "",
			author: "",
			url: "/addticker",
			button: "Set your first stop"
		},
		{
			img: "/george-coyle.jpg",
			quote: "The more I study great traders the more I become convinced that exiting losers very very quickly is the 'secret' weapon.",
			author: "George Coyle",
			button: ""
		},					
		{
			img: "/bernard-baruch.jpg",
			quote: "If you have made a mistake, cut your losses as quickly as possible.",
			author: "Bernard Baruch",
			button: ""
		},					
		
	];

	
	var cardButton = (function(quote) {
    	if (quote.button.length) {
	    	
	    	if (quote.link != undefined) {
		    	return (
					<Button variant="outlined" size="lg" color="primary" onClick={() => {window.open(quote.link)}}>
						{quote.button}
					</Button>
				)		    	
	    	}
	    	else
		    	return (
					<Button className="pulse" variant="outlined" size="lg" color="primary" onClick={() => {navigate(quote.url)}}>
						{quote.button}
					</Button>
				)
    	}
	})
	
    var quotesList = quotes.map(function(quote, index) {
        	return (
				<Grid key={index}>		
					<Card sx={{minHeight: '240px', width: config.cardWidth, bgcolor: config.cardColor, '&:hover': {transform: 'translateY(-2px)'}}}>
												
						<CardCover>
							<img src={process.env.PUBLIC_URL + quote.img} loading="lazy" alt={quote.quote}/>
						</CardCover>
				      
					  	<CardCover sx={{background: 'linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0) 50px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 200px)'}}/>
						
				  		<CardContent sx={{ justifyContent: 'flex-end' }}>
					        <Typography level="title-lg" textColor="neutral.300" fontSize="lg" align="left" mb={-1} sx={{'&:hover': {textColor: 'red'}}} >
								{quote.quote}
					        </Typography>	

					        <Typography level="body-lg" textColor="neutral.500" align="right" fontStyle="italic" mb={1}>
								{quote.author}
					        </Typography>
					        		        					  							        
					        {cardButton(quote)}
					        
				  		</CardContent>				
					  		
					</Card>
				</Grid>
			)
		})		
	
	return (
		<React.Fragment>
			
			<Stack direction="row" justifyContent="flex-end" m={1}>
				<Button color="success" size="lg" variant="outlined" onClick={() => {handleLoginClick()}}>Log in</Button>
			</Stack>			
			
	        <Typography level="h1" align="center"  mb={2} mt={3}>
				Never let a profit turn into a loss.					
	        </Typography>

	        <Typography level="h4" align="center" mb={12}>
				Create smart stops and{' '}		        
				  <Typography variant="soft" color="success">
				    exit like a boss.
				  </Typography>
	        </Typography>
		
			<Grid
			  container
			  justifyContent = "center"
			  spacing={{ xs: 2, md: 3 }}
			  columns={{ xs: 1, sm: 3, md: 6 }}
			  sx={{ flexGrow: 1 }}
			  m={1}
			>	
				{quotesList}			
			</Grid>

		</React.Fragment>
	)		
		
}

export default App;

/*

*/